import axiosInstance from '../axios/interceptors';

export const AuthAPI = {
  verifyToken: () => {
    return axiosInstance.post("/auth/verify");
  },

  getUserProfile: () => {
    return axiosInstance.get("/auth/profile");
  },

  getComponent: (componentSlug) => {
    return axiosInstance.get(`/api/component/${componentSlug}`);
  },

  previewComponent: () => {
    return axiosInstance.get(`/preview/hero-header-sections/section_header27`);
  },
};